import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="w-full bg-primary-950 border-t border-primary-800/40 mt-16">
      <div className="w-full px-4 md:px-8 py-12 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-1">
              <span className="font-heading text-2xl font-extrabold text-primary-400 leading-none">91</span>
              <span className="font-heading text-2xl font-extrabold text-foreground-950 leading-none">.con</span>
            </div>
            <p className="mt-4 text-sm text-foreground-700 leading-relaxed">
              多元娱乐资讯与内容平台。聚合影视、综艺、音乐与热点新闻，为热爱娱乐的你提供丰富、及时、好读的内容体验。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-900/60 text-foreground-800 cursor-pointer hover:bg-primary-800 transition-colors">
                <i className="ri-wechat-line" />
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-900/60 text-foreground-800 cursor-pointer hover:bg-primary-800 transition-colors">
                <i className="ri-weibo-line" />
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-900/60 text-foreground-800 cursor-pointer hover:bg-primary-800 transition-colors">
                <i className="ri-play-circle-line" />
              </span>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950 mb-4">资讯分类</h4>
            <ul className="flex flex-col gap-3">
              {categories.map((c) => (
                <li key={c.key}>
                  <Link to={`/category/${c.key}`} className="text-sm text-foreground-700 hover:text-primary-400 transition-colors cursor-pointer">
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950 mb-4">快速导航</h4>
            <ul className="flex flex-col gap-3">
              <li><Link to="/" className="text-sm text-foreground-700 hover:text-primary-400 transition-colors cursor-pointer">首页</Link></li>
              <li><Link to="/videos" className="text-sm text-foreground-700 hover:text-primary-400 transition-colors cursor-pointer">视频资源</Link></li>
              <li><Link to="/search" className="text-sm text-foreground-700 hover:text-primary-400 transition-colors cursor-pointer">全站搜索</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-700 hover:text-primary-400 transition-colors cursor-pointer">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950 mb-4">联系我们</h4>
            <ul className="flex flex-col gap-3 text-sm text-foreground-700">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-400" />
                contact@91con.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-customer-service-2-line text-primary-400" />
                内容合作 / 商务洽谈
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-primary-400" />
                中国 · 娱乐内容中心
              </li>
            </ul>
            <Link
              to="/about"
              className="mt-5 inline-flex items-center gap-1.5 h-10 px-4 rounded-md bg-accent-500 text-background-50 text-sm font-medium hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-feedback-line" />
              意见反馈
            </Link>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-800/40 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-600">© {year} 91.con 多元娱乐资讯与内容平台 · 保留所有权利</p>
          <p className="text-xs text-foreground-600">本站视频播放与搜索为前端模拟演示，待后端数据接口接入</p>
        </div>
      </div>
    </footer>
  );
}